module.exports = __webpack_public_path__ + "img/img16.ead46aa7.jpg";